module.exports = __webpack_public_path__ + "Roboto-Regular.b2a6341ae7440130ec4b.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-Regular.woff2
// module id = 323
// module chunks = 19